import React from 'react';
// Center
export default function LaydownTrainingIcons({ lang, color }) {
  let icon = null;
  if (lang === 'de') {
    icon = (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" fill={color} width="500" height="325.3" viewBox="0 0 500 325.3" style={{ enableBackground: 'new 0 0 500 325.3' }} xmlSpace="preserve">
        <g>
          <path d="M9.8,67.1V15.5H0V0h37.2v15.5h-9.7v51.6H9.8z" />
          <path d="M69.1,67.1l-5.7-22.3H61v22.3H43.2V0h23.4c12.2,0,20.9,9.5,20.9,21.7c0,11-4.5,16.2-8,18.7l8.6,26.7
              C88.1,67.1,69.1,67.1,69.1,67.1z M69.5,22.4c0-4.4-2.3-6.9-5.8-6.9H61v13.8h2.6C67.1,29.3,69.5,26.8,69.5,22.4z"
          />
          <path d="M121.6,67.1l-1.4-9.4h-10.8l-1.3,9.4H89.9L104.6,0H125l14.8,67.1H121.6z M114.9,19.2l-3.3,23.1h6.6L114.9,19.2z" />
          <path d="M143.3,67.1V0h17.8v67.1H143.3z" />
          <path d="M198.1,67.1l-10.9-28v28h-17.8V0h17.8l9.7,26.2V0h17.7v67.1H198.1z" />
          <path d="M223,67.1V0h33.8v15.5h-16v9.9h15.3v15.5h-15.3v10.8h16v15.5L223,67.1L223,67.1z" />
          <path d="M289.6,67.1l-5.7-22.3h-2.3v22.3h-17.8V0h23.4C299.3,0,308,9.5,308,21.7c0,11-4.5,16.2-8,18.7l8.6,26.7
              C308.6,67.1,289.6,67.1,289.6,67.1z M290,22.4c0-4.4-2.3-6.9-5.8-6.9h-2.6v13.8h2.6C287.7,29.3,290,26.8,290,22.4z"
          />
          <path d="M315.2,67.1V0H349v15.5h-16v9.9h15.3v15.5H333v10.8h16v15.5L315.2,67.1L315.2,67.1z" />
          <path d="M413.1,67.1V34.8l-9.5,32.3h-5.5l-9.3-32.3v32.3H371V0h22l7.8,27L409,0h21.6v67.1H413.1z" />
          <path d="M439,67.1V0h17.8v67.1H439z" />
          <path d="M472.5,67.1V15.5h-9.8V0H500v15.5h-9.7v51.6H472.5z" />
          <path d="M0,299.4l24.3-47.3c10.6,12.3,26.4,18.2,40.5,18.2c10.6,0,16.1-6.5,16.1-14.7c0-28.8-74.4-24.7-74.4-97.4
              c0-35.7,25-71,74.8-71c23,0,44.2,7.5,58.6,20.9L118,154.7c-9.9-9.9-21.6-14.1-34.3-14.1c-9.9,0-15.4,6.2-15.4,14.1
              c0,26.4,74.1,27.1,74.1,96.4c0,42.9-28.5,72.7-73.4,72.7C38.8,323.8,17.1,315.5,0,299.4z"
          />
          <path d="M182.1,319.7v-176h-33.3V90.9h126.9v52.8h-32.9v175.9h-60.7L182.1,319.7L182.1,319.7z" />
          <path d="M296,319.7V90.9h60.7v228.7H296V319.7z" />
          <path d="M384.8,319.7V90.9h60.7v175.9H500v52.8H384.8V319.7z" />
        </g>
      </svg>
);
  } else if (lang === 'fi') {
    icon = (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" fill={color} width="500" height="244.7" viewBox="0 0 500 244.7" style={{ enableBackground: 'new 0 0 500 244.7' }} xmlSpace="preserve">
        <g>
          <path d="M14.9,102.5V23.7H0V0h56.8v23.7H42.1v78.8H14.9z" />
          <path d="M105.4,102.5l-8.8-34.1h-3.5v34.1H65.9V0h35.6c18.6,0,32,14.4,32,33.2c0,16.7-6.9,24.7-12.1,28.6l13.1,40.7H105.4z
               M106,34.3c0-6.8-3.5-10.6-8.9-10.6h-4v21h4C102.5,44.7,106,40.9,106,34.3z"
          />
          <path d="M144.4,102.5V0H196v23.7h-24.4v15.1h23.3v23.7h-23.3v16.4H196v23.7h-51.6V102.5z" />
          <path d="M206.6,102.5V0h51.6v23.7h-24.4v15.1h23.3v23.7h-23.3v16.4h24.4v23.7h-51.6V102.5z" />
          <path d="M312.6,102.5L296,59.8v42.7h-27.2V0H296l14.7,39.9V0h27v102.5H312.6z" />
          <path d="M391.7,102.5l-2.2-14.3h-16.4l-2,14.3h-27.8L365.7,0h31.2l22.6,102.5H391.7z M381.4,29.3l-5.1,35.2h10.1L381.4,29.3z" />
          <path d="M472.2,102.5L470,88.2h-16.4l-2,14.3h-27.8L446.2,0h31.2L500,102.5H472.2z M461.9,29.3l-5.1,35.2H467L461.9,29.3z" />
          <path d="M14.7,244.1v-77.7H0v-23.3h56v23.3H41.5v77.7H14.7z" />
          <path d="M82.3,244.1v-40.7l-24.7-60.2h28.2l9.8,35.1l10-35.1h28.2l-24.7,60.2v40.7H82.3z" />
          <path d="M156.4,244.1v-40.7l-24.7-60.2h28.2l9.8,35.1l10-35.1h28.2l-24.7,60.2v40.7H156.4z" />
          <path d="M213,244.1v-101h26.8v77.7h24.1v23.3H213z" />
          <path d="M272.9,244.1v-101h26.8v101H272.9z" />
          <path d="M312.1,244.1v-101h26.8v77.7H363v23.3H312.1z" />
          <path d="M372.1,244.1v-101h26.8v77.7H423v23.3H372.1z" />
          <path d="M472.6,244.1l-2.1-14.1h-16.2l-2,14.1h-27.4l22.1-101h30.7l22.3,101H472.6z M448.4,136.7c-6.7,0-12.1-5.4-12.1-12.1
              c0-6.7,5.4-12.1,12.1-12.1c6.8,0,12.1,5.4,12.1,12.1C460.5,131.2,455.2,136.7,448.4,136.7z M462.5,172.1l-5,34.7h10L462.5,172.1z
               M476.4,136.7c-6.7,0-12.1-5.3-12.1-12.1c0-6.8,5.4-12.1,12.1-12.1c6.8,0,12.3,5.3,12.3,12.1C488.6,131.4,483.2,136.7,476.4,136.7z
              " />
        </g>
      </svg>
);
  } else if (lang === 'fr') {
    icon = (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" fill={color} width="500" height="195.1" viewBox="0 0 500 195.1" style={{ enableBackground: 'new 0 0 500 195.1' }} xmlSpace="preserve">
        <g>
          <path d="M4.9,89.3V21.1h34.4v15.7H23v10h15.5v15.7H23v10.9h16.3v15.7H4.9V89.3z" />
          <path d="M75.5,89.3l-11-28.4v28.4H46.3V21.1h18.1l9.8,26.6V21.1h18v68.2C92.2,89.3,75.5,89.3,75.5,89.3z" />
          <path d="M108.3,89.3V36.8h-9.9V21.1h37.8v15.7h-9.8v52.5H108.3z" />
          <path d="M168.6,89.3l-5.8-22.7h-2.4v22.7h-18.1V21.1H166c12.4,0,21.3,9.6,21.3,22.1c0,11.1-4.6,16.5-8.1,19l8.7,27.1H168.6z
               M169,43.9c0-4.5-2.4-7.1-5.9-7.1h-2.7v14h2.7C166.6,50.8,169,48.3,169,43.9z"
          />
          <path d="M221.9,89.3l-1.4-9.5h-10.9l-1.3,9.5h-18.5l14.9-68.2h20.8l15,68.2H221.9z M215.1,40.6L211.7,64h6.7L215.1,40.6z" />
          <path d="M257.7,14.9l-4.8-8.1l-4.6,8.1h-8.6l6.1-14.7H260l6.3,14.7H257.7z M244,89.3V21.1h18.1v68.2C262.1,89.3,244,89.3,244,89.3z
              " />
          <path d="M299.7,89.3l-11-28.4v28.4h-18.1V21.1h18.1l9.8,26.6V21.1h18v68.2C316.5,89.3,299.7,89.3,299.7,89.3z" />
          <path d="M324.9,89.3V21.1h34.4v15.7H343v10h15.5v15.7H343v10.9h16.3v15.7h-34.4V89.3z" />
          <path d="M365.2,61.2V47.7h19.1v13.5H365.2z" />
          <path d="M395.2,89.3V36.8h-9.9V21.1h37.8v15.7h-9.8v52.5H395.2z" />
          <path d="M425.8,55.2c0-20.7,7.9-35.3,24.9-35.3s24.8,14.6,24.8,35.3s-7.9,35.3-24.8,35.3C433.6,90.5,425.8,75.9,425.8,55.2z
               M457,55.2c0-11.7-1.6-19.3-6.4-19.3s-6.4,7.7-6.4,19.3s1.6,19.3,6.4,19.3C455.4,74.6,457,66.8,457,55.2z"
          />
          <path d="M481.5,89.3V21.1h18.1v68.2C499.6,89.3,481.5,89.3,481.5,89.3z" />
          <path d="M38.8,192.8l-1.7-11.5H23.9l-1.6,11.5H0l18-82.2h25l18.1,82.2H38.8z M30.6,134.2l-4.1,28.2h8.1L30.6,134.2z" />
          <path d="M74.4,192.8l-18-82.2h22.3l8.3,54.6l8.3-54.6h22.3l-18.1,82.2L74.4,192.8L74.4,192.8z" />
          <path d="M121.8,192.8v-82.2h41.4v19h-19.6v12.1h18.7v19h-18.7v13.2h19.6v19h-41.4C121.8,192.9,121.8,192.8,121.8,192.8z" />
          <path d="M168.9,151.8c0-25.1,9.5-42.5,30.1-42.5c16.3,0,21.4,13.1,24.3,22.9l-17.1,6.3c-1.2-6.3-3-10-7.1-10c-6,0-7.9,9-7.9,23.3
              c0,14.2,1.8,23.3,7.9,23.3c4.4,0,6.5-4.9,7.3-11.5l17,6.2c-2.3,10-7.5,24.5-24.3,24.5C178.4,194.3,168.9,176.8,168.9,151.8z"
          />
          <path d="M243.3,185.6l8.7-17c3.8,4.4,9.5,6.5,14.5,6.5c3.8,0,5.8-2.3,5.8-5.3c0-10.3-26.7-8.9-26.7-35c0-12.8,9-25.5,26.9-25.5
              c8.3,0,15.9,2.7,21.1,7.5l-7.9,16.8c-3.6-3.6-7.8-5.1-12.3-5.1c-3.6,0-5.5,2.2-5.5,5.1c0,9.5,26.6,9.7,26.6,34.6
              c0,15.4-10.2,26.1-26.4,26.1C257.2,194.3,249.4,191.3,243.3,185.6z"
          />
          <path d="M308.7,192.8v-63.2h-11.9v-19h45.6v19h-11.8v63.2H308.7z" />
          <path d="M363.8,192.8v-33.1l-20.1-49h22.9l8,28.6l8.1-28.6h22.9l-20.1,49v33.1L363.8,192.8L363.8,192.8z" />
          <path d="M409.8,192.8v-82.2h21.8v63.2h19.6v19H409.8z" />
          <path d="M458.6,192.8v-82.2H500v19h-19.6v12.1h18.7v19h-18.7v13.2H500v19h-41.4V192.8z" />
        </g>
      </svg>
);
  } else if (lang === 'da') {
    icon = (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" fill={color} width="500" height="345.2" viewBox="0 0 500 345.2" style={{ enableBackground: 'new 0 0 500 345.2' }} xmlSpace="preserve">
        <g>
          <path d="M12.7,87.2v-67H0V0h48.4v20.1H35.8v67L12.7,87.2L12.7,87.2z" />
          <path d="M89.6,87.2l-7.4-29h-3v29H56.1V0h30.3c15.8,0,27.2,12.3,27.2,28.2c0,14.2-5.9,21-10.3,24.3l11.1,34.6L89.6,87.2L89.6,87.2z
               M90.2,29.1c0-5.8-3-9-7.6-9h-3.4V38h3.4C87.2,38,90.2,34.8,90.2,29.1z"
          />
          <path d="M157.3,87.2V75h-13.5l-3.4,12.2H117L147.3,0h53.8v20.1h-20.8v12.8h19.9V53h-19.9v14h20.8v20.1L157.3,87.2L157.3,87.2z
               M157.3,25l-8.1,29.9h8.1V25z"
          />
          <path d="M246.2,87.2l-14.1-36.3v36.3H209V0h23.1l12.5,34V0h23v87.2H246.2z" />
          <path d="M352.7,87.2v-42l-12.3,41.9h-7.2l-12-41.9v41.9h-23.1V0h28.6l10.1,35l10.6-35h28.1v87.2H352.7z" />
          <path d="M386.3,87.2V0h43.9v20.1h-20.8v12.8h19.9V53h-19.9v14h20.8v20.1L386.3,87.2L386.3,87.2z" />
          <path d="M439.2,87.2V0h26.9c24,0,33.9,19.2,33.9,43.6c0,24.7-9.8,43.5-33.7,43.5L439.2,87.2L439.2,87.2z M476.5,43.6
              c0-17.8-4.2-23.5-10.3-23.5h-3.8V67h3.8C472.4,67,476.5,60.2,476.5,43.6z"
          />
          <path d="M0,319.5l24.3-47.3c10.6,12.3,26.4,18.2,40.5,18.2c10.6,0,16.1-6.5,16.1-14.7c0-28.8-74.4-24.7-74.4-97.4
              c0-35.7,25-71,74.8-71c23,0,44.2,7.5,58.6,20.9L118,174.7c-9.9-9.9-21.6-14.1-34.3-14.1c-9.9,0-15.4,6.2-15.4,14.1
              c0,26.4,74.1,27.1,74.1,96.4c0,42.9-28.5,72.7-73.4,72.7C38.8,343.8,17.1,335.6,0,319.5z"
          />
          <path d="M182.1,339.7V163.8h-33.3V111h126.9v52.8h-32.9v175.9H182.1z" />
          <path d="M296,339.7V110.9h60.7v228.7H296V339.7z" />
          <path d="M384.8,339.7V110.9h60.7v175.9H500v52.8H384.8V339.7z" />
        </g>
      </svg>
);
  } else if (lang === 'nl') {
    icon = (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" fill={color} width="500" height="319" viewBox="0 0 500 319" style={{ enableBackground: 'new 0 0 500 319' }} xmlSpace="preserve">
        <g>
          <path d="M15.8,108.5V25.1H0V0h60.2v25.1H44.6v83.5L15.8,108.5L15.8,108.5z" />
          <path d="M111.6,108.5l-9.3-36.1h-3.7v36.1H69.8V0h37.7c19.7,0,33.8,15.3,33.8,35.1c0,17.7-7.3,26.2-12.9,30.3l13.8,43.1
              C142.2,108.5,111.6,108.5,111.6,108.5z M112.3,36.3c0-7.2-3.7-11.2-9.4-11.2h-4.2v22.3h4.2C108.5,47.3,112.3,43.3,112.3,36.3z"
          />
          <path d="M196.6,108.5l-2.3-15.1h-17.4l-2.1,15.1h-29.5L169.1,0h33L226,108.5H196.6z M185.6,31.1l-5.4,37.3H191L185.6,31.1z" />
          <path d="M231.7,108.5V0h28.8v108.5H231.7z" />
          <path d="M320.2,108.5l-17.6-45.2v45.2h-28.8V0h28.8l15.6,42.3V0h28.6v108.5H320.2z" />
          <path d="M384.8,108.5V0h28.8v108.5H384.8z" />
          <path d="M473.3,108.5l-17.6-45.2v45.2h-28.8V0h28.8l15.6,42.3V0H500v108.5H473.3z" />
          <path d="M0,297.4l19.4-37.6c8.5,9.8,21,14.5,32.2,14.5c8.5,0,12.8-5.2,12.8-11.7c0-22.9-59.2-19.6-59.2-77.5
              c0-28.4,19.9-56.5,59.5-56.5c18.3,0,35.2,6,46.6,16.6l-17.5,37.1c-7.9-7.9-17.2-11.2-27.3-11.2c-7.9,0-12.3,4.9-12.3,11.2
              c0,21,58.9,21.5,58.9,76.7c0,34.1-22.6,57.8-58.4,57.8C30.8,316.8,13.6,310.2,0,297.4z"
          />
          <path d="M144.8,313.5V173.6h-26.5v-42h100.9v42H193v139.9H144.8z" />
          <path d="M235.4,313.5V131.6h48.3v181.9H235.4z" />
          <path d="M297.3,309.4l10.9-39.6c3.5,3,9,4.4,13.6,4.4c9.3,0,16.4-5.2,16.4-15.5V131.6h48.3v129.6c0,39-24,55.6-58.6,55.6
              C317.5,316.8,306.1,315.1,297.3,309.4z"
          />
          <path d="M408.3,313.5V131.6h48.3v139.9H500v42H408.3z" />
        </g>
      </svg>
);
  } else if (lang === 'nb') {
    icon = (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" fill={color} width="500" height="351.8" viewBox="0 0 500 351.8" style={{ enableBackground: 'new 0 0 500 351.8' }} xmlSpace="preserve">
        <g>
          <path d="M13.6,93.4V21.6H0V0h51.8v21.6H38.4v71.8H13.6z" />
          <path d="M96,93.4l-8-31.1h-3.2v31.1H60V0h32.5c16.9,0,29.1,13.2,29.1,30.2c0,15.3-6.3,22.5-11.1,26l11.9,37.1L96,93.4L96,93.4z
               M96.6,31.2c0-6.2-3.2-9.7-8.1-9.7h-3.6v19.2h3.6C93.4,40.7,96.6,37.2,96.6,31.2z"
          />
          <path d="M131.6,93.4V0h47v21.6h-22.3v13.7h21.3v21.6h-21.3v15h22.3v21.6L131.6,93.4L131.6,93.4z" />
          <path d="M228.2,93.4L213,54.5v38.9h-24.8V0H213l13.4,36.4V0H251v93.4H228.2z" />
          <path d="M342.2,93.4v-45L329,93.3h-7.7l-12.9-44.9v44.9h-24.8V0h30.7l10.8,37.5L336.5,0h30.1v93.4H342.2z" />
          <path d="M378.2,93.4V0h47v21.6H403v13.7h21.3v21.6H403v15h22.3v21.6L378.2,93.4L378.2,93.4z" />
          <path d="M434.9,93.4V0h28.8C489.4,0,500,20.6,500,46.8c0,26.5-10.5,46.6-36.1,46.6C463.9,93.4,434.9,93.4,434.9,93.4z M474.8,46.8
              c0-19-4.5-25.2-11.1-25.2h-4.1v50.3h4.1C470.5,71.8,474.8,64.5,474.8,46.8z"
          />
          <path d="M0,325.7l24.3-47.3c10.6,12.3,26.4,18.2,40.5,18.2c10.6,0,16.1-6.5,16.1-14.7c0-28.8-74.4-24.7-74.4-97.4
              c0-35.7,25-71,74.8-71c23,0,44.2,7.5,58.6,20.9L118,180.9c-9.9-9.9-21.6-14.1-34.3-14.1c-9.9,0-15.4,6.2-15.4,14.1
              c0,26.4,74.1,27.1,74.1,96.4c0,42.9-28.5,72.7-73.4,72.7C38.8,350,17.1,341.8,0,325.7z"
          />
          <path d="M182.1,345.9V170h-33.3v-52.8h126.9V170h-32.9v175.9H182.1z" />
          <path d="M296,345.9V117.1h60.7v228.7H296V345.9z" />
          <path d="M384.8,345.9V117.1h60.7V293H500v52.8H384.8V345.9z" />
        </g>
      </svg>
);
  } else if (lang === 'sv') {
    icon = (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" fill={color} width="500" height="363.9" viewBox="0 0 500 363.9" style={{ enableBackground: 'new 0 0 500 363.9' }} xmlSpace="preserve">
        <g>
          <path d="M11.7,105.6v-62H0V24.9h44.7v18.6H33.1v62L11.7,105.6L11.7,105.6z" />
          <path d="M82.9,105.6L76,78.8h-2.8v26.8H51.9V24.9H80c14.6,0,25.2,11.4,25.2,26.1c0,13.2-5.4,19.5-9.6,22.5l10.3,32L82.9,105.6
              L82.9,105.6z M83.4,51.9c0-5.3-2.8-8.3-7-8.3h-3.1v16.6h3.1C80.7,60.1,83.4,57.1,83.4,51.9z"
          />
          <path d="M146.1,105.6l-1.7-11.2h-12.9l-1.6,11.2H108l17.7-80.7h24.5l17.8,80.7H146.1z M126.7,19.7c-5.3,0-9.7-4.4-9.7-9.7
              s4.4-9.7,9.7-9.7c5.4,0,9.7,4.4,9.7,9.7C136.4,15.4,132.2,19.7,126.7,19.7z M138,48l-4,27.7h8L138,48z M149.1,19.7
              c-5.3,0-9.7-4.2-9.7-9.7s4.4-9.7,9.7-9.7c5.4,0,9.8,4.2,9.8,9.7S154.5,19.7,149.1,19.7z"
          />
          <path d="M206.6,105.6L193.5,72v33.6h-21.4V24.9h21.4l11.7,31.5V24.9h21.3v80.7H206.6z" />
          <path d="M268.9,105.6l-1.7-11.2h-12.9l-1.6,11.2h-21.9l17.7-80.7H273l17.8,80.7H268.9z M260.8,48l-4,27.7h8L260.8,48z" />
          <path d="M363.7,105.6V66.8l-11.4,38.8h-6.7l-11.1-38.8v38.8h-21.4V24.9h26.5l9.4,32.5l9.8-32.4h26v80.7L363.7,105.6L363.7,105.6z" />
          <path d="M394.8,105.6V24.9h40.6v18.6h-19.2v11.9h18.4V74h-18.4v12.9h19.2v18.6L394.8,105.6L394.8,105.6z" />
          <path d="M443.8,105.6V24.9h24.9c22.1,0,31.3,17.8,31.3,40.4c0,22.9-9.1,40.3-31.2,40.3H443.8z M478.2,65.3
              c0-16.4-3.9-21.8-9.6-21.8h-3.5v43.4h3.5C474.5,87,478.2,80.7,478.2,65.3z"
          />
          <path d="M0,337.9l24.3-47.3c10.6,12.3,26.4,18.2,40.5,18.2c10.6,0,16.1-6.5,16.1-14.7c0-28.8-74.4-24.7-74.4-97.4
              c0-35.7,25-71,74.8-71c23,0,44.2,7.5,58.6,20.9L118,193.2c-9.9-9.9-21.6-14.1-34.3-14.1c-9.9,0-15.4,6.2-15.4,14.1
              c0,26.4,74.1,27.1,74.1,96.4c0,42.9-28.5,72.7-73.4,72.7C38.8,362.2,17.1,354,0,337.9z"
          />
          <path d="M182.1,358.1V182.2h-33.3v-52.8h126.9v52.8h-32.9v175.9H182.1z" />
          <path d="M296,358.1V129.4h60.7v228.7H296z" />
          <path d="M384.8,358.1V129.4h60.7v175.9H500v52.8L384.8,358.1L384.8,358.1z" />
        </g>
      </svg>
);
  } else {
    icon = (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" fill={color} width="500" height="294.7" viewBox="0 0 500 294.7" style={{ enableBackground: 'new 0 0 500 294.7' }} xmlSpace="preserve">
        <g>
          <path d="M15.8,107.8V24.9H0V0h59.8v24.9H44.3v82.9H15.8z" />
          <path d="M110.9,107.8l-9.2-35.9H98v35.9H69.3V0h37.6c19.5,0,33.7,15.2,33.7,34.9c0,17.6-7.3,26-12.8,30l13.7,42.8L110.9,107.8
              L110.9,107.8z M111.6,36.1c0-7.1-3.8-11.2-9.4-11.2H98v22.2h4.2C107.8,47,111.6,42.9,111.6,36.1z"
          />
          <path d="M195.3,107.8L193,92.7h-17.4l-2,15.1h-29.2L168,0h32.8l23.8,107.8H195.3z M184.4,30.8l-5.4,37h10.6L184.4,30.8z" />
          <path d="M230.2,107.8V0h28.7v107.8H230.2z" />
          <path d="M318.3,107.8l-17.5-45v45h-28.7V0h28.7l15.5,42V0h28.4v107.8H318.3z" />
          <path d="M473.6,107.8l-17.5-45v45h-28.7V0h28.7l15.5,42V0H500v107.8H473.6z" />
          <path d="M385.3,107.8V0H414v107.8H385.3z" />
          <path d="M0,276.3l17-33.1c7.4,8.6,18.5,12.7,28.3,12.7c7.4,0,11.3-4.6,11.3-10.3c0-20.2-52.1-17.3-52.1-68.1
              c0-25,17.5-49.7,52.3-49.7c16.1,0,30.9,5.3,41,14.6L82.4,175c-7-7-15.1-9.8-24-9.8c-7,0-10.8,4.3-10.8,9.8
              c0,18.5,51.8,19,51.8,67.4c0,30-19.9,50.9-51.3,50.9C27.1,293.4,12,287.6,0,276.3z"
          />
          <path d="M127.4,290.5V167.4h-23.3v-36.9h88.8v36.9h-23v123.1H127.4z" />
          <path d="M234.6,290.5V226l-39.1-95.5h44.6l15.6,55.7l15.8-55.7h44.6L277,226v64.5H234.6z" />
          <path d="M324.4,290.5v-160h42.5v123.1H405v36.9H324.4z" />
          <path d="M419.4,290.5v-160H500v36.9h-38.1v23.5h36.5v36.9h-36.5v25.7H500v36.9h-80.6V290.5z" />
        </g>
      </svg>
);
  }
  return (
    <div className="iconHolder laydownTrainingIconHolder training">
      {icon}
    </div>
  );
}
